import { createAction } from '@reduxjs/toolkit';

import type { ReadonlyFontAsset } from 'js/src/data/fonts/fonts-types';
import { FONTS_ACTIONS } from 'js/src/data/fonts/fonts-types';

export const beginLoadingFonts = createAction<undefined>(FONTS_ACTIONS.BEGIN_LOADING_FONTS);

export const storeFonts = createAction<{
    fontList: readonly ReadonlyFontAsset[];
}>(FONTS_ACTIONS.STORE_FONTS);

export const archiveFontWithId = createAction<{
    fontId: number;
}>(FONTS_ACTIONS.ARCHIVE_FONT_WITH_ID);
